// extracted by css-extract-rspack-plugin
export default {"minimalPaddingsWrapper":"minimal-paddings-wrapper--isgL9aTbPFAiikpc"};